import { axios } from '@/plugins/axios-pol'

const BASE = '/personal/api/EstadoFuerza'

export default class TipoNovedadApiRepository {
  async getAllTipos() {
    const { data } = await axios.get(`${BASE}/tipoNovedad`)
    return data.data
  }
}
